module.exports = __webpack_public_path__ + "img/loader2.38817472.svg";